import { styled } from 'baseui'

export const SectionCardContainer = styled('div', ({ $theme }) => ({
  backgroundColor: $theme.colors.white,
  borderRadius: '0.5rem',
  border: `0.0625rem solid ${$theme.colors.borderLight}`,
  padding: '0.85rem',
  boxSizing: 'border-box',
}))
